import { HeadLogo } from "../components/headLogo";
import { BackButton } from "../components/backButton";
import { CheckpointListItem } from "../components/checkpointListItem";


function CheckpointListView({
  userCheckpointsData,
  sortedLocations,
  visitedIds,
  onDiscover,
}) {
  return (
    <div className="checkpoint-Container">
      <HeadLogo />
        <BackButton title={"Checkpoint List"} />
      <div className="checkpoint-section">
      
        <div className="profile-checkpoint-header">Tap a checkpoint to begin your Time & Space journey.</div>
         </div>
      
        <div className="profile-infoContainer">
          <CheckpointListItem
            sortedLocations={sortedLocations}
            visitedIds={visitedIds}
            userCheckpointsData={userCheckpointsData}
            onDiscover={onDiscover}
          />
       
        <div className="checkpoint-list"></div>
      </div>
    </div>
  );
}

export { CheckpointListView };
